import React from "react";
import { IonCard, IonCardContent } from "@ionic/react";
import i18n from "i18n";
import "./Commodities.scss";
import { ComponentProps } from "./types";
import DetailsCommodities from "./DetailsCommodities/DetailsCommodities";
import AdditionalCommodities from "./AdditionalCommodities/AdditionalCommodities";

export default ({
  commodities: { detailsCommodities, additionalCommodities }
}: ComponentProps) => {
  return (
    <div className="commodities-component">
      {!!detailsCommodities.length ? (
        <div className="commodities">
          <DetailsCommodities detailsCommodities={detailsCommodities} />
          {!!additionalCommodities.length && (
            <AdditionalCommodities
              additionalCommodities={additionalCommodities}
            />
          )}
        </div>
      ) : (
        <IonCard class="no-commodities-found">
          <IonCardContent>
            <div>{i18n.t("No commodities were found.")}</div>
          </IonCardContent>
        </IonCard>
      )}
    </div>
  );
};
